document.querySelectorAll('[data-newsletter-archive]').forEach((archive) => {
    const button = archive.querySelector('[data-newsletter-more]')

    if (!button) {
        return
    }

    const perPage = parseInt(archive.dataset.perPage, 10) || 12

    button.addEventListener('click', () => {
        const hidden = archive.querySelectorAll('.newsletter__card[hidden]')
        const batch = Array.prototype.slice.call(hidden, 0, perPage)

        batch.forEach((card) => card.removeAttribute('hidden'))

        const firstLink = batch.length ? batch[0].querySelector('a:not([tabindex="-1"])') : null

        if (firstLink) {
            firstLink.focus()
        }

        if (hidden.length <= perPage) {
            button.parentNode.remove()
        }
    })
})
